import React, { Component } from 'react';
import style from '../share/pageUpdate.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DefaultBtn from '../../components/DefaultBtn.js';
//import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';
//import MultipleCheckedWithLabel from '../../components/MultipleCheckedWithLabel.js';
//import * as utils from '../../Utils.js';


class CompanyEmployeeUpLoad extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            // dataObject: null,
            // userObject: null,
            // companyId: this.props.companyId,
            // validateObject: null,
            //validateMessage: "",
            loading: false,
            fileData: null,
            fileName: "",
            url: ""

        };
        this.validateMessage = "";
    }

    selectFileBtnClick = () => {
        let self = this;
        this.validateMessage = "";
        let id = document.getElementById("image-file");
        id.onchange = function (e) {
            let c_id = document.getElementById("image-file").files[0];
            //console.log(c_id);
            //alert(c_id.name);
            self.state.fileData = c_id;
            self.state.fileName = c_id.name;
            document.getElementById("image-file").value = null;
            self.setState({});
        }
        id.click();
    }
    uploadFileBtnClick = (e)=>{
        //alert("55");
        if(this.state.fileName === ""){
            this.validateMessage = "Please select file.";
            this.setState({
                //validateMessage : "Please select file."
            })
        }
        else{
            //alert("up");
            this.uploadFile();
        }           
    }
    hahdleChange = ()=>{

    }

    handleClick=(method, idx, e)=> {

        //alert(method);


        // if (e.target.name === "Upload") {
        //     //this.callSetData();

        //     if(this.fileName === ""){
        //         this.setState({
        //             validateMessage : "Please select file."
        //         })
        //     }
        //     else{

        //     }           
        // }



        // if (method === "selectFile") {
        //     //alert("xxx");
        //     let self = this;
        //     this.state.validateMessage = "";
        //     let id = document.getElementById("image-file");
        //     id.onchange = function (e) {
        //         let c_id = document.getElementById("image-file").files[0];
        //         //console.log(c_id);
        //         //alert(c_id.name);
        //         self.state.fileData = c_id;
        //         self.state.fileName = c_id.name;
        //         document.getElementById("image-file").value = null;
        //         self.setState({});
        //     }
        //     id.click();
        // }
    }
    uploadFile() {
        let appState = this.props.appState;
        let companyId = appState.userObject.companyId;
        console.log(appState);
        let self = this;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/uploadEmployee";
        //let url = baseUrl + "/api/multiagencyapi/uploadMarkup";
        let formData = new FormData();
        formData.append("Id", companyId);
        let file = self.state.fileData;
        formData.append("file", file, file.name);


        axios
            .post(url, formData, {
                headers: {
                    'Authorization': appState.userObject.Token
                }
            })
            .then(response => {
                this.uploadFileCallBack(response.data);
            })
            .catch(err => {
                console.error(err)
            })

        this.setState({
            loading: true
        })
    }
    uploadFileCallBack = (res) => {
        //alert("Upload compleated.");
        //console.log(res);
        this.props.onClose();

        //this.props.handleClick("hideUploadMarkup", null, null);
    }
    render() {
        return (
            <div className={style.createArea}>
                <BackDropLoading show={this.state.loading} />
                <div className={style.contentBox}>

                    <div className={style.contentTitle}>upload File</div>
                    <div className={style.line}></div>


                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="url" label="URL:" value={this.state.fileName} errorMessage={this.validateMessage} onChange={this.hahdleChange} />
                    </div>
                    <div className={style.sectionInput}>
                        {/* <div className={style.uplaod_btn}>Select File</div> */}
                        <div className={style.primaryBoxBtn}>
                            <DefaultBtn label="Select File" onClick={this.selectFileBtnClick} name="SelectFile" type="info" />
                        </div>
                    </div>


                    {/* <div className={style.rowInput}>
                        <CheckBoxWithLabel name="Enable" label="Active" value={dataObject.IsEnable} errorMessage="" onChange={this.handleChange} />
                    </div>
                    // <div className={style.rowInput}>
                    //     <CheckBoxWithLabel name="IsApprover" label="IsApprover" value={dataObject.IsApprover} errorMessage="" onChange={this.handleChange} />
                    // </div>
                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="FirstName" label="FirstName" value={dataObject.FirstName} errorMessage={validateObject.FirstName} onChange={this.handleChange} />
                    </div>
                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="LastName" label="LastName" value={dataObject.LastName} errorMessage={validateObject.LastName} onChange={this.handleChange} />
                    </div>

                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="Email" label="Email" value={dataObject.Email} errorMessage={validateObject.Email} onChange={this.handleChange} />
                    </div>

                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="Phone" label="Phone" value={dataObject.Phone} errorMessage={validateObject.Phone} onChange={this.handleChange} />
                    </div>
                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="Department" label="Department" value={dataObject.Department} errorMessage={validateObject.Department} onChange={this.handleChange} />
                    </div>
                    <div className={style.sectionInput}>
                        <TextBoxWithLabel name="Position" label="Position" value={dataObject.Position} errorMessage={validateObject.Position} onChange={this.handleChange} />
                    </div> */}


                    <input className={style.image_file} id="image-file" type="file" />


                    <div className={style.btnRow}>
                        <div className={style.btnRowCenter}>


                            {/* {this.props.method === "Create" &&
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                </div>
                            }
                            {this.props.method === "Edit" &&
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                </div>
                            }
                            {this.props.method === "Delete" &&
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Delete" onClick={this.handleClick} name="Delete" type="danger" />
                                </div>
                            } */}
                            <div className={style.primaryBoxBtn}>
                                <DefaultBtn label="Upload" onClick={this.uploadFileBtnClick} name="Upload" type="primary" />
                            </div>
                            <div className={style.primaryBoxBtn}>
                                <DefaultBtn label="Back" onClick={this.props.onClose} name="Back" type="default" />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );

    }


    //this.callGetData();
    //alert("CompanyUserControlUpdate");

}


export default CompanyEmployeeUpLoad;